import Image from 'next/image';

const APP_STORE_URL = 'https://apps.apple.com/app/id6778140599';
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.iterogo.tours';

/**
 * Badges oficiales de descarga (App Store + Google Play).
 * App Store primero (izquierda), Google Play segundo (derecha).
 * En móvil se apilan y centran; en desktop van en fila.
 * Se usan los badges en español para los 20 idiomas (assets únicos).
 */
export default function AppDownloadButtons({
  className = '',
}: {
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col sm:flex-row items-center gap-3 sm:gap-4 ${className}`}
    >
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Descargar IteroGO en el App Store"
        className="inline-block transition-opacity hover:opacity-90"
      >
        <Image
          src="/badge_appstore_es.png"
          alt="Descargar en el App Store"
          width={1197}
          height={400}
          className="h-12 md:h-14 w-auto"
          priority
        />
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Descargar IteroGO en Google Play"
        className="inline-block transition-opacity hover:opacity-90"
      >
        <Image
          src="/GetItOnGooglePlay_Badge_Web_color_Spanish.png"
          alt="Disponible en Google Play"
          width={478}
          height={142}
          className="h-12 md:h-14 w-auto"
        />
      </a>
    </div>
  );
}
